export const alertsSectionTabs = {
  alerts: "alerts",
  evaluationList: "evaluation-list",
  woundRisk: "wound-risk"
};
